import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

const Loading = ({ height }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: height ? height : "100vh",
        color: "#7352c7",
      }}
    >
      <CircularProgress />
    </div>
  );
};

export default Loading;
